const carMonitor = {
  systemsummary: {
    navigation: {
      sitemap: "แผนผังเว็บไซต์"
    }
  },
  monitorinfo: {
    carStatus: {
      offonlinetimegreaterthan: "Offline time greater than",
      useageofvehicle: "Useage of vehicle",
      online: "Online",
      offline: "Offline",
      commercialvehicle: "Commercial-vehicle",
      testvehicle: "Test-vehicle",
      comparisonvehicle: "Comparison-vehicle",
      unlocated: "Unlocated",
      located: "Located",
      stopped: "Stopped",
      moving: "Moving",
      signaledcan: "Signaled",
      nonsignaledcan: "Non-signaled",
      days: "วัน",
      hours: "ชม.",
      minutes: "นาที",
      seconds: "วินาที",
      datasubmissiontime: "เวลาในการส่งข้อมูล",
      lastonlinetime: "เวลาเชื่อมต่อล่าสุด",
      GPSpositioning: "สถานะ GPS",
      whethermoving: "Whether moving",
      whetherhavecansignal: "Whether have can-signal",
      voltage:"แรงดันไฟฟ้าแบตเตอรี่",
      coolantTemporature:"เครื่องยนต์เย็นอุณหภูมิ",
      whetherterminalisonline: "สถานะเครื่องยนต์",
      offonlinetime: "ระยะเวลาดับเครื่อง",
      vehiclecurrentposition: "Vehicle current position",
      failedtogetwebsocketaddress: "Failed to get websocket address",
      realTimeDialog: {
        carRealData: "ข้อมูลเรียลไทม์",
        carRealBattery: "Current battery power (SOC)",
        lastdatasubmissiontime: "Final Data Time",
        vehicleTypeCode: "VehicleTypeCode",
        internalCode: "Batch lot",
        productmodel: " ProductModel",
        usearea: "UseArea",
        signalstrength: "SignalStrength",
        GPSmileage: "GPSMileage",
        CANData: "CAN Data",
        Speed: "Speed",
        No: "No",
        Yes: "Yes",
        gpsTime: "เวลา GPS",
        carLatPos: "รายงานตำแหน่งล่าสุดก่อนรถออฟไลน์",
        carRun: "ข้อมูลรถยนต์ขณะวิ่ง",
        isOnLine: "เครื่องยนต์ เรียลไทม์ ออนไลน์"
      },
      area: "จังหวัด",
      model: "โมเดล",
      search: {
        width1: "100",
        width2: "80",
        width3: "60",
        width4: "60"
      }
    }
  },
  plateNumber: "License plate",
  OBDwidth: "50px",
  logo: "ยี่ห้อ",
  carModel: "โมเดล",
  series: "ซีรี่ย์",
  tips: "Please enter",
  vehicleConfiguration: "ซีรี่ย์",
  conditionMonitoring: "Condition monitoring",
  vehicle: {
    realtimeData: "Vehicle real-time parameters",
    width1: "175px",
    searchWidth: "90px",
    SOC: "Current battery level",
    yesonline: "Online",
    noonline: "not online",
    yes: "yes",
    no: "no",
    yesdriving: "travel",
    nodriving: "stop",
    yesCan: "Has CAN",
    noCan: "Without CAN",
    isonline: "Whether the terminal is online",
    lastActiveTime: "Last data reporting time",
    areaName: "applied area",
    gpsPosition: "Whether to locate",
    isdriving: "Whether to exercise",
    gpsMileage: "GPS mileage",
    gpsSpeed: "GPS speed",
    canHasData: "CAN data",
    realtimeError: "No data",
    speedCard: "speed",
    lastParames: "Last reported data before vehicle offline"
  },
  electric: {
    electricManage: {
      alarmrulesname: "Alarm name",
      rulestype: "ประเภทกฎ",
      creattime: "เวลาสร้าง",
      starttime: "Start time",
      endtime: "End time",
      placeholder: "Placeholder",
      administrativeAreas: "Administrative Areas",
      polygon: "Polygon",
      circular: "Circular",
      outOf: "OutOf",
      alarmType: "จำนวนการเดินทาง (ครั้ง)",
      speedThreshold: "Speed threshold",
      alarmVehicle: "จำนวนรถยนต์",
      description: "Description",
      createdby: "Created by",
      createdon: "เวลาสร้าง",
      deleteAlert: "Please select the item to delete",
      alert1: "Whether or not to delete",
      prompt: "Prompt",
      confirm: "Confirm",
      cancel: "Cancel",
      successfullyDelete: "Delete successfully",
      setCarAlert: "Please select the electronic fence rule",
      detailCarDialog: {
        vehicledetail: "รายละเอียดขอบเขตแจ้งเตือน",
        licensePlate: "License plate",
        typename: "TypeName",
        batchcode: "Batch lot"
      },
      wlxq: "รายละเอียดขอบเขตแจ้งเตือน",
      wlss: "ภายใต้",
      wlxx: "ข้อมูลขอบเขตแจ้งเตือน",
      carTitle: "ยานพาหนะ",
      radius: "รัศมี",
      createdByYourself: "Created by yourself",
      readOnly: "No",
      editable: "Yes",
      readOnlyTip: "You don't have permission to operate this item",
      addVehicleTip: "You are going to add vehicles to your electronic fence",
      subCompany: "Sub Company",
      department: "Department",
      subUserTip: "You can create an electronic fence for your "
    },
    electricNotes: {
      licensePlate: "License plate",
      alarmType: "จำนวนการเดินทาง (ครั้ง)",
      alarmTime: "เวลาปลุก",
      starttime: "Alarm time",
      endtime: "เวลาสิ้นสุด",
      alarmrulesname: "Alarm name",
      address: "ที่อยู่ที่แจ้งเตือน",
      whetherended: "Whether ended",
      alarmMessage: "ข้อความ",
      fenceMessage: "ข้อมูลของขอบเขตแจ้งเตือน",
      alarmCar: "ข้อความแจ้งเตือน",
      outOf: "Drive out",
      overspeed: "Overspeed",
      unfinished: "Unfinished",
      finished: "Finished",
      alarmsubtype: "Alarmsub type",
      currentalarmspeed: "Current alarm speed",
      userName: "Mobile No",
      ruleName: "ชื่อขอบเขตแจ้งเตือน",
      ruleType: "ประเภทขอบเขต",
      status: "status",
      ending: "Has ended",
      noending: "Not over yet",
      width1: "140px",
      width2: "120px",
      width3: "90px",
      alarmDetail: "รายละเอียดขอบเขต"
    }
  },
  terminalCommand: {
    commandName: "Command package name",
    startTime: "Start time",
    endTime: "End time",
    paramscount: "Number of commands",
    loginname: "Founder",
    createdon: "Creation time",
    commondStatus: "Command packet status",
    remark: "Remarks",
    function: "operating",
    see: "View",
    notperformed: "Not performed",
    Finishedperformed: "Finished",
    Inprogress: "In progress",
    add: "Create",
    data: "parameter",
    okBtn: "Confirm",
    cancleBtn: "Cancle",
    doubleClick: "Double click to operate",
    upload: "ที่อัพโหลด",
    setData: "Setting parameters",
    packetnameTips: "Please enter the command package name",
    addFuncTips: "Please add an action",
    addSuccess: "Added successfully",
    browse: "เรียกดู",
    yes: "Yes",
    file: "file",
    explanation: "Explanation",
    checkFile: "Please select a file",
    versionnumber: "version number",
    uploadUrl: "Upload path",
    isSet: "Whether to set the default",
    dbcTips: "Please fill in the DBC storage path",
    regexText: "Please fill in the pkg storage path",
    such: "Such as",
    bitian: "This item is required",
    gxbun: "The item cannot be",
    success: "ความสำเร็จ",
    uploadSuccess: "อัปโหลดไฟล์เรียบร้อยแล้ว",
    uploadFileTips: "Please select upload file",
    uploadFilereset: "This file has been uploaded. Please re select the uploaded file",
    uploadLoading: "File uploading",
    formate: "Please fill in the form correctly",
    width1: "100px",
    width2: "180px",
    width3: "80px",
    width4: "100px",
    width: "100px",
    searchWidth: {
      width1: "165px",
      width2: "80px"
    }
  },
  terminalBatch: {
    commandWdith: "160px",
    taskName: "ชื่องาน",
    commandName: "ชื่อแพ็กเกจคำสั่ง",
    vin: "VIN code",
    loginname: "ผู้สร้าง",
    createtime: "สร้างเวลา",
    paramscount: "จำนวนคำสั่ง",
    yichexiao: "ยกเลิก",
    notperformed: "ไม่ได้ดำเนินการ",
    Inprogress: "กำลังดำเนินการ",
    Finishedperformed: "เสร็จแล้ว",
    failedcount: "การดำเนินการล้มเหลว",
    tingzx: "ระงับการดำเนินการ",
    weizhi: "ไม่ทราบ",
    see: "ดูรายละเอียดงาน",
    seeBatch: "View command package",
    function: "ปฏิบัติการ",
    add: "เพิ่มงานคำสั่งออฟไลน์",
    selectCar: "เลือกยานพาหนะ",
    selectObd: "เลือกอุปกรณ์ OBD",
    import: "นำเข้า",
    reset: "Reset",
    carMessage: "Vehicle information",
    okCheck: "Selected",
    numberCar: "cars",
    notCar: "No vehicle is currently selected",
    remark: "หมายเหตุ",
    okBtn: "ยืนยัน",
    cancleBtn: "Cancle",
    tasknameTips: "โปรดป้อนชื่องาน",
    selectCarTips: "โปรดเลือกหมายเลขอุปกรณ์ OBD",
    packetnameTips: "Please enter the command package name",
    addSuccess: "เพิ่มเรียบร้อยแล้ว",
    seeParames: "ดูพารามิเตอร์แพ็คเกจคำสั่ง",
    data: "พารามิเตอร์",
    obdTaskDetail: "รายละเอียดงานอัพเกรด OBD",
    taskDetail: "รายละเอียดคำสั่งงาน",
    cartypeid: "Model name",
    carbatchid: "Project code",
    terminalcode: "Task terminal",
    online: "on-line",
    notOnline: "Not online",
    export: "export",
    allStatus: "เสร็จสิ้นโดยรวม",
    ml: "คำสั่ง",
    mlParames: "พารามิเตอร์คำสั่ง",
    wancheng: "เสร็จสิ้น",
    selectName: "Select command name",
    width3: "80px",
    width4: "120px",
    searchWidth: {
      width1: "170px",
      width2: "90px",
      width3: "130px"
    },
    upgrade: "อัพเกรดแพ็คเกจ",
    createUpgrade: "สร้างแพ็คเกจอัพเกรด",
    HistoricalUpgrade: "แพ็คเกจอัพเกรดย้อนหลัง",
    uploadFiles: "อัพโหลดไฟล์",
    version: "เวอร์ชัน",
    versionDescription: "คำอธิบายเวอร์ชัน",
    historicalVersion: "รุ่นประวัติศาสตร์",
    addObdTask: "เพิ่มงานอัพเกรด OBD",
    error: {
      message1: "โปรดป้อนหมายเลขเวอร์ชัน",
      message2: "โปรดเลือกอัปโหลดไฟล์",
      message3: "โปรดเลือกเวอร์ชันเก่า",
      message4: "โปรดอัปโหลดไฟล์. bin"
    }
  },
  terminalControl: {
    title: "การดีบักระยะไกล",
    fileManagement: "การจัดการไฟล์เทอร์มินัล",
    loadDir: "โหลดไดเร็กทอรีเทอร์มินัล",
    downloadFiles: "ดาวน์โหลดไฟล์",
    shellCommandTitle: "คำสั่งเชลล์",
    shellCommand: "คำสั่ง",
    implement: "ดำเนินการ",
    res: "กลับ",
    downloadingData: "กำลังดาวน์โหลดข้อมูล ...",
    systemPrompt: "พร้อมต์ระบบ"
  },
  trip: {
    starttime: "Start time",
    searchWidth: {
      width1: "50px"
    },
    startLngLat: "เริ่มต้นละติจูดและลองจิจูด",
    endttime: "End time",
    endLngLat: "สิ้นสุดลองจิจูดและละติจูด",
    accelerate: "จำนวนการเร่งความเร็วอย่างรวดเร็ว",
    slowdown: "จำนวนการชะลอตัวที่คมชัด",
    sharpturnCunt: "จำนวนรอบคม"
  }
}
export default carMonitor